import {
  Bookmark,
  BrainCircuit,
  CheckCircle2,
  FileText,
} from "lucide-react"
import {
  STUDENT_BASE_PATH,
  STUDENT_BOOKMARKS_PATH,
  STUDENT_PRACTICE_PAPERS_PATH,
  STUDENT_QUESTIONS_PATH,
} from "../../../../component/student/config/studentNavItems"
import type { DashboardStat, DashboardStatsSummary } from "../types"

const QUESTIONS_PATH = STUDENT_QUESTIONS_PATH
const AI_PATH = `${STUDENT_BASE_PATH}/ai-assessor`
const BOOKMARKS_PATH = STUDENT_BOOKMARKS_PATH

export const buildDashboardStatCards = (
  summary: DashboardStatsSummary
): DashboardStat[] => [
  {
    title: "Question Attempts Made",
    value: summary.totalAttempts,
    trend:
      summary.totalAttempts > 0
        ? `${summary.papersInProgress} in progress`
        : "Start attempting",
    icon: CheckCircle2,
    iconTone: "emerald",
    to: QUESTIONS_PATH,
  },
  {
    title: "Practice Papers",
    value: summary.papersInProgress + summary.papersCompleted,
    trend:
      summary.papersInProgress > 0
        ? `${summary.papersInProgress} in progress`
        : `${summary.papersCompleted} completed`,
    icon: FileText,
    iconTone: "blue",
    to: STUDENT_PRACTICE_PAPERS_PATH,
  },
  {
    title: "AI Assessments",
    value: summary.aiAssessmentsCount,
    trend:
      summary.avgAiAssessmentScore !== null
        ? `Avg ${summary.avgAiAssessmentScore}%`
        : "No scores yet",
    icon: BrainCircuit,
    iconTone: "primary",
    to: AI_PATH,
  },
  {
    title: "Saved & Notes",
    value: summary.savedItemsCount,
    trend: `${summary.bookmarkedCount} bookmarks · ${summary.notesCount} notes`,
    icon: Bookmark,
    iconTone: "amber",
    to: BOOKMARKS_PATH,
  },
]
